var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FF8A00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13245_45862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25003 7.53552V4.25C8.25003 3.6986 7.80143 3.25 7.25003 3.25H6.20705L6.85352 2.60352L6.5 2.25L5.25 3.5L6.5 4.75L6.85352 4.39648L6.20705 3.75H7.25003C7.52573 3.75 7.75003 3.97438 7.75003 4.25V7.53552C7.31998 7.64735 7.00003 8.0354 7.00003 8.5C7.00003 9.0514 7.44863 9.5 8.00003 9.5C8.55143 9.5 9.00003 9.0514 9.00003 8.5C9.00003 8.0354 8.68008 7.64735 8.25003 7.53552ZM8.00003 9C7.72433 9 7.50003 8.77562 7.50003 8.5C7.50003 8.22438 7.72433 8 8.00003 8C8.27573 8 8.50003 8.22438 8.50003 8.5C8.50003 8.77562 8.27573 9 8.00003 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3.5C3 3.9646 3.31995 4.35265 3.75 4.46447V7.53552C3.31995 7.64727 3 8.03535 3 8.5C3 9.05152 3.4486 9.5 4 9.5C4.5514 9.5 5 9.05152 5 8.5C5 8.03535 4.68005 7.64727 4.25 7.53552V4.46447C4.68005 4.35265 5 3.9646 5 3.5C5 2.9486 4.5514 2.5 4 2.5C3.4486 2.5 3 2.9486 3 3.5ZM4.5 8.5C4.5 8.77562 4.27575 9 4 9C3.72425 9 3.5 8.77562 3.5 8.5C3.5 8.22438 3.72425 8 4 8C4.27575 8 4.5 8.22438 4.5 8.5ZM4.5 3.5C4.5 3.77575 4.27575 4 4 4C3.72425 4 3.5 3.77575 3.5 3.5C3.5 3.22425 3.72425 3 4 3C4.27575 3 4.5 3.22425 4.5 3.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13245_45862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPr);
export default __webpack_public_path__ + "static/media/pr.ee2a80854fedcfbc58e1b5e3383f11d0.svg";
export { ForwardRef as ReactComponent };